import type { TVConfig } from '@nuxt/ui';
import type * as ui from '#build/ui';

export default {
    variants: {
        variant: {
            subtle: {
                root: ''
            }
        }
    },
} satisfies TVConfig<typeof ui>['card'];
